import { Stack, Typography } from '@mui/material'
import { FC } from 'react'

interface IFormSubjectAnswerHandler {
  subject: any
  subjectIndex: number
}

const FormSubjectAnswerHandler: FC<IFormSubjectAnswerHandler> = ({ subject, subjectIndex }) => {
  const valueRender = (data: string | number) => (data ? data : '-')

  return (
    <>
      <Stack key={subject.id} className='t-form-section t-subject'>
        <Typography variant='bodyBold'>Subject {subjectIndex + 1}</Typography>
        <Stack>
          <Typography variant='labelBold'>Subject Name</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject?.full_name)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Phone Number</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject?.phone_number)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Description</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject?.description)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work Site</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject?.work_site)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work City</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject.city)}</Typography>
        </Stack>
        <Stack>
          <Typography variant='labelBold'>Work Country</Typography>
          <Typography variant='bodyRegular'>{valueRender(subject.country)}</Typography>
        </Stack>
      </Stack>
    </>
  )
}

export default FormSubjectAnswerHandler
